import jsPDF from "jspdf";
import "jspdf-autotable";

const invoiceGeneratePdf = (
  data,
  invNo,
  invdate,
  provider,
  facilityname,
  providerStreet,
  providerCity,
  providerState,
  providerNum,
  providerMail,
  patName,
  patNumber,
  patStreet,
  patCity,
  patState,
  patZip,
  patEmail,
  amount,
  balance,
  ext,
  Base,
  statelogo,
  symbol,
) => {
  const doc = new jsPDF("p", "mm", "a4");

  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  /* ================= HEADER ================= */
  if (statelogo !== "0" && Base) {
    try {
      doc.addImage(Base, ext, 10, 10, 35, 25); // Bigger logo
    } catch (e) {}
  }

  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text("INVOICE", pageWidth - 20, 18, { align: "right" });

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Invoice No: ${invNo}`, pageWidth - 20, 26, { align: "right" });
  doc.text(`Invoice Date: ${invdate}`, pageWidth - 20, 32, { align: "right" });

  /* ================= INFO CARDS ================= */
  const cardY = 45;
  const cardHeight = 32;

  doc.setDrawColor(230);
  doc.roundedRect(10, cardY, 90, cardHeight, 3, 3);
  doc.roundedRect(110, cardY, 90, cardHeight, 3, 3);

  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text("Billed From:", 14, cardY + 8);
  doc.text("Billed To:", 114, cardY + 8);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text(
    doc.splitTextToSize(
      `${facilityname}\n${providerStreet}\n${providerCity}\n${providerState} \n Email: ${providerMail}`,
      85,
    ),
    14,
    cardY + 14,
  );

  doc.text(
    doc.splitTextToSize(
      `${patName}\n${patStreet}\n${patCity}, ${patState} ${patZip}, \n Email: ${patEmail}`,
      85,
    ),
    114,
    cardY + 14,
  );

  /* ================= PROVIDER & CLIENT ================= */
  const pcY = cardY + cardHeight + 10;

  doc.roundedRect(10, pcY, 90, 28, 3, 3);
  doc.roundedRect(110, pcY, 90, 28, 3, 3);

  doc.setFont("helvetica", "bold");
  doc.text("Provider:", 14, pcY + 8);
  doc.text("Client:", 114, pcY + 8);

  doc.setFont("helvetica", "normal");
  doc.text(
    doc.splitTextToSize(
      `${provider}\nTax ID: ${providerNum}\n${providerMail}\n`,
      85,
    ),
    14,
    pcY + 14,
  );

  doc.text(
    doc.splitTextToSize(
      `${patName}\nPhone: ${patNumber}\nEmail: ${patEmail}`,
      85,
    ),
    114,
    pcY + 14,
  );

  /* ================= TABLE ================= */
  const rows = data.map((d) => [d.date, d.serviceName, `${symbol}${d.fee}`]);

  doc.autoTable({
    startY: pcY + 40,
    head: [["Date", "Description", "Amount"]],
    body: rows,
    theme: "grid",
    headStyles: {
      fillColor: [37, 99, 235], // Blue header
      textColor: 255,
      fontSize: 11,
    },
    bodyStyles: {
      fontSize: 10,
    },
    styles: {
      halign: "left",
      cellPadding: 6,
    },
    columnStyles: {
      2: { halign: "right" },
    },
  });

  const finalY = doc.lastAutoTable.finalY;

  const labelX = pageWidth - 90;
  const valueX = pageWidth - 20;

  /* -------- TOTAL -------- */
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Total", labelX, finalY + 12);

  doc.text(`${symbol}${amount}`, valueX, finalY + 12, {
    align: "right",
  });

  // Divider line (very important for Figma look)
  doc.setDrawColor(180);
  doc.setLineWidth(0.3);
  doc.line(labelX, finalY + 16, valueX, finalY + 16);

  /* -------- MAKE PAYMENT -------- */
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Make Payment to:", labelX, finalY + 24);

  doc.text(facilityname, valueX, finalY + 24, {
    align: "right",
  });

  /* ================= FOOTER ================= */
  doc.setFontSize(9);
  doc.setTextColor(120);
  doc.text("Powered by Vozo", pageWidth / 2, pageHeight - 10, {
    align: "center",
  });

  doc.save(`invoice_${patName}_${invNo}.pdf`);
};

export default invoiceGeneratePdf;
